import { Helmet } from 'react-helmet';
import ProductDetail
  from 'src/components/product-detail/ProductDetail';

import {
  Box,
  Container,
} from '@material-ui/core';

import ProductListToolbar from '../components/product-detail/ProductToolbar';

const Product = () => (
  <>
    <Helmet>
      <title>Quản lý sản phẩm</title>
    </Helmet>
    <Box
      sx={{
        backgroundColor: 'background.default',
        minHeight: '100%',
        py: 3
      }}
    >
      <Container style={{maxWidth: "100%"}}>
        <ProductListToolbar />
        <Box sx={{ pt: 3 }}>
          <ProductDetail />
        </Box>
      </Container>
    </Box>
  </>
);

export default Product;
